import { render, staticRenderFns } from "./DmhArticles.vue?vue&type=template&id=4b0f60b7"
import script from "./DmhArticles.vue?vue&type=script&lang=js"
export * from "./DmhArticles.vue?vue&type=script&lang=js"
import style0 from "./DmhArticles.vue?vue&type=style&index=0&id=4b0f60b7&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports